import {
  createContext,
  FC,
  ReactElement,
  useContext,
  useMemo,
  useState,
} from 'react'

export enum UiVersion {
  'V1' = 'v1',
  'V2' = 'v2',
}

const DEFAULT_UI_VERSION = UiVersion.V2

const ThemeSettingsContext = createContext<{
  uiVersion: UiVersion
  setUiVersion: (uiVersion: UiVersion) => void
  isV2: boolean
}>({
  uiVersion: DEFAULT_UI_VERSION,
  setUiVersion: () => {},
  isV2: true,
})

export const useThemeSettings = () => useContext(ThemeSettingsContext)

export const ThemeSettingsProvider: FC<{ children: ReactElement }> = ({
  children,
}) => {
  const [uiVersion, setUiVersion] = useState<UiVersion>(DEFAULT_UI_VERSION)

  const values = useMemo(
    () => ({
      setUiVersion,
      uiVersion,
      isV2: uiVersion === UiVersion.V2,
    }),
    [uiVersion],
  )

  return (
    <ThemeSettingsContext.Provider value={values}>
      {children}
    </ThemeSettingsContext.Provider>
  )
}
